module.exports = __webpack_public_path__ + "static/media/gateway.1305668f.png";